import { Container, Form, Alert, Tab, Tabs} from 'react-bootstrap';
import {Sida,Rubrik,Stycke,Button,ContentWrapper} from "./ContentStyles";
import React, { useState ,useEffect, useReducer, fetchData, useMemo} from 'react';
import {MaterialReactTable, showRowExpandColumn} from 'material-react-table';

// Smarta funktioner
import useBackend, {CallAPI,  Spinner, UserData} from '../services/useBackend';

export default function Test() {

  // Hämta användarinfo från token
  const {IsLoggedIn, token}      = UserData();

  // Hämta data till tabell
  const {loading, data, Refresh, Seek} =  useBackend(process.env.PUBLIC_URL+'/api/cities');

  // Egenskaper till tabell
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
  const initialState = { density: 'compact', columnVisibility: { } };
  const state = { pagination };

  // Till tabellen
  const columns = useMemo(() => [    
    { size: 40, accessorKey: 'name', header: 'City', enableColumnActions: false },
    { size: 40, accessorKey: 'guid', header: 'Guid', enableColumnActions: false },
  ]); 

  return (    
    <Container>
      <Sida>
        {IsLoggedIn ? (<Rubrik>{token.name}</Rubrik>):(<Rubrik>Ej inloggad</Rubrik>) }

        {!loading &&
        <><MaterialReactTable columns={columns} data={data.cities} state={state} initialState={initialState}  
            onPaginationChange={setPagination} manualPagination= {false}  autoResetPageIndex= {false}
            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, 
            showRowExpandColumn: true, rowsPerPageOptions: [25, 50, 75, 100], labelRowsPerPage:"Rader" }}
        /><br></br>
        <Button className="QmeButton" variant="primary" type="submit" onClick={Refresh}>Uppdatera</Button></>
        }
			</Sida>
		</Container>
  );
}